module.exports = __webpack_public_path__ + "027b0495e6f2efb3d01aa1b128d2aa94.jpg";